import { c as _c } from "react/compiler-runtime";
import type { PaidPlan } from '@/types/billing-plan';
import { CheckIcon } from 'lucide-react';
import type { PlanComparisonCard } from '../plan-comparison';
import { SHARED_PLAN_FEATURES } from '../plan-comparison';
import { PlanCard } from './plan-card';
import { PlanFeature } from './plan-feature';
import { Skeleton } from '@/components/ui/skeleton';
type PlanComparisonCardsProps = {
  cards: PlanComparisonCard[];
  selectedPlan?: PaidPlan | null;
  currentPlan?: PaidPlan;
  onCtaClick?: (plan: PaidPlan) => void;
};
export function PlanComparisonCards(t0) {
  const $ = _c(15);
  const {
    cards,
    selectedPlan,
    currentPlan,
    onCtaClick
  } = t0;
  let t1;
  if ($[0] !== cards || $[1] !== currentPlan || $[2] !== onCtaClick || $[3] !== selectedPlan) {
    let t2;
    if ($[5] !== currentPlan || $[6] !== onCtaClick || $[7] !== selectedPlan) {
      t2 = card => <PlanCard key={card.plan} card={card} isSelected={selectedPlan === card.plan} isCurrentPlan={currentPlan === card.plan} onCtaClick={() => onCtaClick?.(card.plan)} />;
      $[5] = currentPlan;
      $[6] = onCtaClick;
      $[7] = selectedPlan;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = cards.map(t2);
    $[0] = cards;
    $[1] = currentPlan;
    $[2] = onCtaClick;
    $[3] = selectedPlan;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <div className="grid items-start gap-6 lg:grid-cols-3">{t1}</div>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h3 className="mb-4 text-sm font-medium text-zinc-400">Included in every plan</h3>;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="mt-6 border-t border-border px-1 pt-5" aria-label="Included in every plan">{t3}<ul className="grid gap-x-8 gap-y-3 text-sm text-zinc-400 sm:grid-cols-2">{SHARED_PLAN_FEATURES.map(_temp)}</ul></section>;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2) {
    t5 = <section className="mx-auto max-w-6xl">{t2}{t4}</section>;
    $[13] = t2;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp(feature) {
  return <li key={typeof feature === "string" ? feature : feature.label} className="flex items-start gap-2"><CheckIcon className="mt-0.5 size-4 shrink-0" aria-hidden="true" /><PlanFeature feature={feature} /></li>;
}
export function PlanComparisonCardsSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="mx-auto max-w-6xl"><div className="grid gap-6 lg:grid-cols-3"><Skeleton className="h-[32rem] w-full rounded-xl" /><Skeleton className="h-[32rem] w-full rounded-xl" /><Skeleton className="h-[32rem] w-full rounded-xl" /></div></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}